<div class="rating-box">
  <div class="rating" [style.width.%]="safeRating"></div>
</div>